<template>
  <v-app-bar class="wrapper-app-bar wrapper-app-bar--mobile">
    <v-container
      class="wrapper-toolbar wrapper-toolbar-mobile pa-0"
      :style="{ left: $vuetify.rtl ? '0' : '', right: !$vuetify.rtl ? '0' : '' }"
    >
      <!-- RTL right: menu → year → support → chat -->
      <div class="appbar-mobile__start" dir="rtl">
        <button
          type="button"
          class="appbar-mobile__icon-btn"
          :aria-label="menuCaption"
          @click="menuHubOpen = true"
        >
          <my-icon
            name="menu-layout-icon"
            :width="22"
            :height="22"
            stroke="#5B7C99"
            :cursor-pointer="true"
          />
        </button>

        <button
          type="button"
          class="appbar-mobile__year-chip"
          :aria-label="$t('Year')"
          :disabled="loading"
          @click="openYearSheet"
        >
          <v-icon size="16" color="#5B7C99">mdi-calendar-month-outline</v-icon>
          <span class="appbar-mobile__year-chip-text">
            {{ $store.state.year }}
          </span>
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="14"
            width="2"
            color="#5B7C99"
          />
          <v-icon v-else size="18" color="#5B7C99">mdi-chevron-down</v-icon>
        </button>

        <div class="appbar-mobile__icon-btn appbar-mobile__icon-btn--wrap">
          <UserSupport :touchable="true" />
        </div>

        <div class="appbar-mobile__icon-btn appbar-mobile__icon-btn--wrap">
          <UserConversation :touchable="true" />
        </div>
      </div>

      <!-- RTL left: profile -->
      <div class="appbar-mobile__end">
        <UserMenuMobile />
      </div>
    </v-container>

    <MenuHubMobile v-model="menuHubOpen" />
    <!-- Always mounted so list pages can open file-process via $root emit -->
    <UserFileProcess hide-activator />

    <!-- year picker layer -->
    <v-bottom-sheet v-model="yearSheetOpen" scrollable>
      <v-card class="appbar-mobile__year-sheet">
        <div class="appbar-mobile__year-sheet-handle" />
        <div class="appbar-mobile__year-sheet-header" dir="rtl">
          <span class="appbar-mobile__year-sheet-spacer" />
          <div class="appbar-mobile__year-sheet-title">{{ $t("Year") }}</div>
          <button
            type="button"
            class="appbar-mobile__year-sheet-close"
            :aria-label="$t('back')"
            @click="yearSheetOpen = false"
          >
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>

        <div class="appbar-mobile__year-sheet-body" dir="rtl">
          <div
            v-if="loading && !yearItems.length"
            class="appbar-mobile__year-sheet-loading"
          >
            <v-progress-circular indeterminate color="#5B7C99" size="28" />
          </div>
          <button
            v-for="(year, i) in yearItems"
            :key="i"
            type="button"
            class="appbar-mobile__year-item"
            :class="{
              'appbar-mobile__year-item--active': isActiveYear(year),
            }"
            @click="selectYear(year)"
          >
            <span class="appbar-mobile__year-item-name">{{ year.name }}</span>
            <v-icon
              v-if="isActiveYear(year)"
              size="20"
              color="#5B7C99"
            >
              mdi-check
            </v-icon>
          </button>
        </div>
      </v-card>
    </v-bottom-sheet>
  </v-app-bar>
</template>

<script>
import UserSupport from "@/views/dashboard/components/core/appbar/partial/UserSupport.vue";
import UserConversation from "@/views/dashboard/components/core/appbar/partial/UserConversation.vue";
import UserMenuMobile from "@/views/dashboard/components/core/appbar/partial/UserMenuMobile.vue";
import UserFileProcess from "@/views/dashboard/components/core/appbar/partial/UserFileProcess.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import MenuHubMobile from "@/views/dashboard/components/core/appbar/mobile/MenuHubMobile.vue";

export default {
  name: "AppBarMobile",
  data() {
    return {
      yearItems: [],
      loading: false,
      menuHubOpen: false,
      yearSheetOpen: false,
    };
  },
  components: {
    UserSupport,
    UserConversation,
    UserMenuMobile,
    UserFileProcess,
    MyIcon,
    MenuHubMobile,
  },
  computed: {
    menuCaption() {
      const t = this.$t("menu");
      if (t && t !== "menu") return t;
      return "منو";
    },
  },
  methods: {
    isActiveYear(year) {
      const current = this.$store.state.financialYear;
      if (!year || !current) return false;
      return current.id === year.id;
    },
    openYearSheet() {
      this.yearSheetOpen = true;
      this.getYears();
    },
    selectYear(year) {
      if (this.isActiveYear(year)) {
        this.yearSheetOpen = false;
        return;
      }
      this.yearSheetOpen = false;
      this.changeYear(year);
    },
    getYears() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "year",
            search: null,
            page: 1,
          },
        })
        .then((res) => {
          res = res.data;
          app.yearItems = res.data;
          app.allYears = res.data;
          if (
            app.allYears &&
            app.allYears.length > 0 &&
            app.$store &&
            app.$store.state.financialYear &&
            app.$store.state.financialYear.id === app.allYears[0].id
          ) {
            app.$store.commit("SET_ISMAINYEAR", true);
          } else {
            app.$store.commit("SET_ISMAINYEAR", false);
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
    changeYear(item) {
      if (this.$store.state.financialYear.id === item.id) return false;
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "changeYear",
            year: item,
          },
        })
        .then((res) => {
          res = res.data;
          var storage = JSON.parse(localStorage.getItem("token"));
          storage.init.startDate = res.start_date;
          storage.init.endDate = res.end_date;
          storage.init.financialYear = res;
          storage.init.year = res.name;
          localStorage.setItem("token", JSON.stringify(storage));

          app.$store.commit("SET_YEAR", res.name);
          app.$store.commit("SET_FINANCIALYEAR", res);
          app.$store.commit("SET_START_DATE", res.start_date);
          app.$store.commit("SET_END_DATE", res.end_date);
          location.reload();
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
  },
  mounted() {
    this.getYears();
  },
};
</script>

<style>
.wrapper-app-bar.wrapper-app-bar--mobile {
  height: 52px !important;
  padding: 0 10px;
  position: fixed;
  z-index: 3;
  display: flex;
  align-items: center;
  background: #ffffff !important;
  border-bottom: 1px solid #eef2f6 !important;
  /* box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.08) !important; */
  box-shadow: none !important;
}
.wrapper-app-bar .wrapper-toolbar {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrapper-app-bar .wrapper-toolbar.wrapper-toolbar-mobile {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.wrapper-app-bar .v-toolbar__content {
  height: 52px !important;
  width: 100%;
}

.appbar-mobile__start {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.appbar-mobile__end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  height: 36px;
}

/* same blue as year chip fill */
.appbar-mobile__start .appbar-touchable svg [stroke]:not([stroke="none"]) {
  stroke: #5b7c99 !important;
}

.appbar-mobile__start .appbar-touchable svg [fill]:not([fill="none"]):not([fill="transparent"]) {
  fill: #5b7c99 !important;
}

.appbar-mobile__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: rgba(91, 124, 153, 0.08);
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.appbar-mobile__icon-btn:active {
  background: rgba(91, 124, 153, 0.16);
}

.appbar-mobile__icon-btn--wrap {
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent !important;
}

.appbar-mobile__icon-btn--wrap:active {
  background: transparent !important;
}

.appbar-mobile__icon-btn--wrap .v-container {
  padding: 0 !important;
  margin: 0 !important;
}

.appbar-mobile__icon-btn--wrap .v-btn {
  width: 36px !important;
  height: 36px !important;
  margin: 0;
  background: transparent !important;
}

.appbar-mobile__icon-btn--wrap .appbar-touchable__btn {
  width: 36px !important;
  height: 36px !important;
  background: transparent !important;
}

.appbar-mobile__icon-btn--wrap .appbar-touchable__btn:active {
  background: rgba(91, 124, 153, 0.08) !important;
}

.appbar-mobile__year-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  min-height: 36px;
  padding: 0 8px;
  border: 1.5px solid #5b7c99;
  border-radius: 10px;
  background: rgba(91, 124, 153, 0.08);
  color: #5b7c99;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.15s ease;
}

.appbar-mobile__year-chip:active {
  background: rgba(91, 124, 153, 0.16);
  transform: scale(0.98);
}

.appbar-mobile__year-chip:disabled {
  opacity: 0.75;
}

.appbar-mobile__year-chip-text {
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  color: #5b7c99;
  letter-spacing: 0.02em;
}

.appbar-mobile__year-sheet {
  border-radius: 16px 16px 0 0 !important;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.appbar-mobile__year-sheet-handle {
  width: 36px;
  height: 4px;
  border-radius: 999px;
  background: #cfd8dc;
  margin: 10px auto 4px;
  flex-shrink: 0;
}

.appbar-mobile__year-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 10px;
  border-bottom: 1px solid #eef2f6;
  flex-shrink: 0;
}

.appbar-mobile__year-sheet-title {
  font-size: 16px;
  font-weight: 700;
  color: #1c2a3a;
}

.appbar-mobile__year-sheet-spacer,
.appbar-mobile__year-sheet-close {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.appbar-mobile__year-sheet-close {
  border: none;
  background: transparent;
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
}

.appbar-mobile__year-sheet-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 8px 12px 20px;
}

.appbar-mobile__year-sheet-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 8px;
}

.appbar-mobile__year-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  margin: 0 0 8px;
  padding: 10px 14px;
  border: 1px solid #e8eef3;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  text-align: right;
  -webkit-tap-highlight-color: transparent;
}

.appbar-mobile__year-item:active {
  background: #f7f9fc;
}

.appbar-mobile__year-item--active {
  border-color: #bbdefb;
  background: #e3f2fd;
}

.appbar-mobile__year-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #37474f;
}
</style>
